import React, { useState } from "react";
import { FiHome, FiBox, FiGlobe, FiBarChart2, FiFileText } from "react-icons/fi";
import { FaHandsHelping } from "react-icons/fa";

import { useLocation } from "react-router-dom";
import ProductCategoryAndComplianceRequirements from "../Results/ProductCategoryAndComplianceRequirements";
import HarmonizedSystemOfNomenclature from "../Results/HarmonizedSystemOfNomenclature";
import Market from "../Results/Market";
import DutyDrawback from "../Results/DutyDrawback";
import DocumentationGenerator from "../Results/Documentation";
import Dashhome from "../Results/Dashhome";
import Logo from "../assets/logodark.png";
import { TbListNumbers } from "react-icons/tb";
import Documentation from "../Documentation/Documentation";

const menuItems = [
  { id: 'home', icon: FiHome, label: 'Dashboard' },
  { id: 'product', icon: FiBox, label: 'Product Category' },
  { id: 'hsn', icon: TbListNumbers, label: 'HSN GST, RoDTEP' },
  { id: 'market', icon: FiGlobe, label: 'Market Analysis' },
  { id: 'duty', icon: FiBarChart2, label: 'Duty Drawback' },
  { id: 'documents', icon: FiFileText, label: 'Required Documents' },
];

export default function Dashboard() {
  const location = useLocation();
  const formData = location.state?.formData || {};
  const [activeTab, setActiveTab] = useState('home'); // Set 'home' as the default tab
  const [isSidebarExpanded, setIsSidebarExpanded] = useState(false);

  const renderComponent = () => {
    switch (activeTab) {
      case 'product':
        return <ProductCategoryAndComplianceRequirements 
        exportingCountry={formData.exportingCountry}
            destinationCountry={formData.destinationCountry}
            businessDetails={formData.businessDetails}
            products={formData.products}
            selectedState={formData.selectedState}
            selectedDistrict={formData.selectedDistrict}
            keywords={formData.keywords}
            />;
      case 'hsn':
        return (
          <HarmonizedSystemOfNomenclature
            exportingCountry={formData.exportingCountry}
            destinationCountry={formData.destinationCountry}
            businessDetails={formData.businessDetails}
            products={formData.products}
            selectedState={formData.selectedState}
            selectedDistrict={formData.selectedDistrict}
            keywords={formData.keywords}
          />
        );
      case 'market':
        return <Market 
        exportingCountry={formData.exportingCountry}
            destinationCountry={formData.destinationCountry}
            businessDetails={formData.businessDetails}
            products={formData.products}
            selectedState={formData.selectedState}
            selectedDistrict={formData.selectedDistrict}
            keywords={formData.keywords}/>;
      case 'duty':
        return <DutyDrawback 
        exportingCountry={formData.exportingCountry}
            destinationCountry={formData.destinationCountry}
            businessDetails={formData.businessDetails}
            products={formData.products}
            selectedState={formData.selectedState}
            selectedDistrict={formData.selectedDistrict}
            keywords={formData.keywords}/>;
      case 'documents':
        return <DocumentationGenerator 
        exportingCountry={formData.exportingCountry}
            destinationCountry={formData.destinationCountry}
            businessDetails={formData.businessDetails}
            products={formData.products}
            selectedState={formData.selectedState}
            selectedDistrict={formData.selectedDistrict}
            keywords={formData.keywords}/>;
      case 'help':
        return <Documentation 
        exportingCountry={formData.exportingCountry}
            destinationCountry={formData.destinationCountry}
            businessDetails={formData.businessDetails}
            products={formData.products}
            selectedState={formData.selectedState}
            selectedDistrict={formData.selectedDistrict}
            keywords={formData.keywords}/>; // Renamed Documentation case to Help
      case 'home':
      default:
        return <Dashhome setActiveTab={setActiveTab} 
        exportingCountry={formData.exportingCountry}
            destinationCountry={formData.destinationCountry}
            businessDetails={formData.businessDetails}
            products={formData.products}
            selectedState={formData.selectedState}
            selectedDistrict={formData.selectedDistrict}
            keywords={formData.keywords}
        />; // Render Dashhome by default
    }
  };

  return (
    <div className="flex h-screen">
      {/* Sidebar */}
      <div
        className={`transition-all duration-300 ease-in-out ${
          isSidebarExpanded ? 'w-64' : 'w-20'
        } bg-gray-900 shadow-lg`} // Changed to dark theme
        onMouseEnter={() => setIsSidebarExpanded(true)}
        onMouseLeave={() => setIsSidebarExpanded(false)}
      >
        <div className="flex items-center justify-center h-16 border-b border-gray-700">
          <img src={Logo} alt="Logo" className="w-10" />
        </div>
        <nav className="mt-6">
          {menuItems.map((item) => (
            <button
              key={item.id}
              className={`flex items-center w-full px-4 py-3 transition-colors duration-200 ${
                activeTab === item.id
                  ? 'bg-indigo-600 text-white'
                  : 'text-gray-300 hover:bg-gray-700'
              } transition-all duration-300 ${!isSidebarExpanded ? 'justify-center' : ''}`}
              onClick={() => setActiveTab(item.id)}
            >
              <item.icon className="w-5 h-5 mr-3" />
              {isSidebarExpanded && <span className="font-medium">{item.label}</span>}
            </button>
          ))}
        </nav>
      </div>

      {/* Main content */}
      <div className="flex-1 overflow-auto relative">
        <header className="bg-white dark:bg-gray-800 shadow-sm">
          <div className=" py-4 px-4 sm:px-6 lg:px-8 flex justify-between items-center">
            <h2 className="text-2xl font-bold leading-tight text-gray-900 dark:text-white">
              Smart International Business Advisors
              <span className="ml-2 px-2 py-1 text-xs font-semibold text-indigo-600 border border-indigo-600 rounded-full">BETA</span>
            </h2>
            <button
  className="flex items-center px-4 py-2 border border-indigo-600 text-indigo-600 rounded-md hover:bg-indigo-100"
  onClick={() => setActiveTab('help')}
>
  <FaHandsHelping className="w-5 h-5 mr-2" />
  How to Export
</button>
          </div>
        </header>
        <main className="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">
          {renderComponent()}
        </main>
      </div>
    </div>
  );
}